import React from "react";
import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { MomentCard } from "@/components/MomentCard";

export const RoteiroStep = ({
  moments, onMomentsChange, onSearch, onAssistant, pendingIds = [],
}) => {
  const updateMoment = (updated) =>
    onMomentsChange(moments.map((m) => (m.id === updated.id ? updated : m)));

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className="mx-auto max-w-2xl"
    >
      <h2 className="font-serif text-2xl font-semibold text-[color:var(--brand-graphite)] sm:text-3xl">
        Músicas de cada momento
      </h2>
      <p className="mt-2 text-sm text-[color:var(--brand-muted)]">
        Agora escolha a trilha de cada momento do seu cortejo.
      </p>
      <div className="mt-3 flex items-start gap-2 rounded-xl border border-[color:var(--brand-champagne)] bg-[color:var(--brand-champagne-soft)] p-3 text-sm text-[color:var(--brand-graphite)]">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--brand-marsala)]" />
        <span>
          <strong>* Dicas:</strong> confirme a versão exata da música (original, acústica, instrumental...) colando um
          link de referência. Marque <strong>⭐ surpresa</strong> quando ninguém pode saber, e use
          "Ainda não decidimos" para voltar depois.
        </span>
      </div>

      <div className="mt-5 space-y-4">
        {moments.map((m, i) => (
          <MomentCard
            key={m.id}
            moment={m}
            index={i}
            structural={false}
            onChange={updateMoment}
            onSearch={() => onSearch(m.id)}
            onAssistant={() => onAssistant(m.id)}
            isPending={pendingIds.includes(m.id)}
          />
        ))}
      </div>
    </motion.div>
  );
};
